module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/stride-54d85daa8aab0767d3e6d77c840eb19f.png";